export const doctor=[
    // {title:'طرح تحقیق رساله دورۀ دکتـری ',link:'pd.doc'},
    // {title:'انتخاب استاد راهنما و موضوع رساله ',link:'endr.doc'},
    // {title:'پیشنهـاد استـاد راهنمای دوم (دکتری) ',link:'reh2.doc'},
    // {title:'پیشنهـاد استـاد مشـاور(دکتری) ',link:'moshdr.doc'},
    // {title:'پیشنهاد موضوع رساله دکتری ',link:'padr.doc'},
    {title:'تحویل رساله دکتری ',link:'tahdr.doc'},
    {title:'درخواست امتحان جامع دکتری ',link:'jamdr.doc'},
    {title:'درخواست جلسه پیش دفاع از رساله ',link:'pishdr.doc'},
    {title:'گزارش سمینار شش ماهه رساله ',link:'semdr.doc'},
    {title:'گزارش سه ماهه دکتری ',link:'g3dr.doc'},
    {title:'دستورالعمل اعلام كفايت دستاوردهای پژوهشی',link:'g3dr.doc'},
    {title:'آیین نامه دوره دکتری ورودی 1397',link:'aeenDr.pdf'},
    {title:'آیین نامه و شیوه نامه اجرایی آموزشی دوره دکتری دانشجویان ورودی سال 1395 و مابعد',link:'sheeveh.pdf'},
    {title:'فرم شماره 5 - طرحنامه تفصیلی رساله دکتری',link:'5d.doc'},
    {title:'فرم شماره 4 - طرح کلی پیشنهاد موضوع رساله ، استاد راهنما و مشاور',link:'4d.doc'},
]
export const master =[
    // {title:'طرح پیشنهادی پایان نامه',link:'pm.doc'},
    // {title:'پیشنهاد استاد مشاور پایان‌نامه',link:'moshm.doc'},
    // {title:'پیشنهاد موضوع پایان نامه',link:'pamr.doc'},
    {title:'تحویل پایان نامه کارشناسی ارشد',link:'tah.doc'},
    // {title:'انتخاب استاد راهنما و تصویب پایان‌نامه',link:'tasmr1.doc'},
    {title:'درخواست مجوز دفاع كارشناسی ارشد ',link:'defa.doc'},
    {title:'گزارش سه ماهه کارشناسی ارشد',link:'g3dr.doc'},
    {title:'مدارک تحویلی پایان نامـه پس از دفاع ',link:'mad.pdf'},
    {title:'آئین نامه آموزشی مقطع کارشناسی ارشد ناپیوسته برای دانشجویان ورودی ۱۳۹۷ و ما بعد',link:'master.pdf'},
    {title:'فرم شماره 1 -پیشنهاد موضوع پایان نامه استاد راهنما و مشاور',link:'1m.doc'},
    {title:'فرم شماره 2 - طرح کلی پیشنهاد پایان نامه کارشناسی ارشد',link:'2m.docx'},
    {title:'فرم شماره 3 - طرحنامه تفصیلی پایان نامه کارشناسی ارشد',link:'3m.doc'},
    // {title:'فرم شماره 4 - فرم انتخاب استاد مشاور',link:'moshaver.doc'},
    // {title:'طرح اجمالی پایان‌نامه کارشناسی‌ارشد جهت طرح در کمیته',link:'tarh1402.doc'},
    {title:'فرم درخواست',link:'darkhast1402.doc'},
]
export const common =[
    {title:'دستورالعمل نحوه نگارش پایان‌نامه كارشناسی ارشد و دکترا ',link:'dastor.pdf'},
    {title:'تقاضانامه ترک تحصیل دائم دانشجویان دکتری / کارشناسی ارشد',link:'tark.doc'},
    {title:'فرم چکیده انگلیسی ',link:'chen.doc'},
    {title:'فرم چکیده فارسی ',link:'chfa.doc'},
    {title:'فرم تایید انجام اصلاحات رساله / پایان نامه بعد از جلسه دفاع ',link:'es.doc'},
    {title:'فرم درخواست صدور معرفی نامه جهت تحقیق پژوهشی ',link:'tahda.doc'},
    {title:'استعـلام سـوابق تحصیـلی',link:'estelam.pdf'},
    {title:'اقرارنامه حقوق ناشی از پایان نامه / رساله',link:'eghrarnameh.pdf'},
    {title:'الگوی نامه تغییرات پروپوزال',link:'olgo.doc'},
    {title:'تعهدنامه اصالت علمی رساله دکتری',link:'esalat.pdf'},
    {title:'مراحل تسویه حساب دانشجویان تحصیلات تکمیلی ',link:'tasvieh.pdf'},
    {title:'دستورالعمل بررسی غیبت در امتحانات پایان نیمسال و بررسی مدارک پزشکی دانشچویان' ,link:'dastoorGheybat.pdf'},
    {title:'فرم درخواست بررسی مدارک پزشگی با توجه به دستورالعمل بررسی امتحانات پایان نیمسال تحصیلی',link:'formGheybat.pdf'},
    {title:'آيين نامۀ شورای استعدادهای درخشان دانشگاه شهيدبهشتی',link:'derakhshan.pdf'},
    {title:'مراحل تسویه حساب دانشجویان با کتابخانه دانشگاه شهید بهشتی',link:'tasviehLib.pdf'},

]
